//#region IMPORT
import React, { useState, useEffect, useRef } from 'react';
/** Services Import */
import Commons from '../../../../Services/Common/Common';
import Global from '../../../../Services/Common/Global';
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { v4 as uuidv4 } from 'uuid';
/** Components */
import { PLA_BASIC } from './index';
import { Loading } from '../../../../Components/MUIs';
import {
  setChanged,
  setDeleted,
  setRowData,
  setSelected,
} from '../../../../Reducer/GridReducer';
import { FileForm } from '../../../../Components/FileForm';
import { Box, Typography, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Icon from '../../../../Assets/Icon/CustomIcons';
import useErrorHandler from '../../../../hooks/useErrorHandler';
import usePartialRefresh from '../../../../hooks/usePartialRefresh';
import useFileUpload from '../../../../hooks/useFileUpload';
import useDelete from './../../../../hooks/useDeleteN';
import {
  useDelete1,
  useSearch1,
  useSearch3,
  useSearch2,
  useSave2,
  useSave3,
  useSave1,
} from './PLA_BASIC_QUERY';
import { PLA_BASIC_Schema } from './PLA_BASIC_Schema';
import { createInitial, toPreviewSrc } from '../../../../util';
import { useSave } from '../../../../hooks/useSaveN';
//#endregion

//#region 상수
// 화면 MENU_ID
const SCREEN_MENU_ID = 'Plant';
const COL_WIDTH = ['20%', '30%', '20%', '30%'];

//#endregion

function PLA_BASICF() {
  //#region 변수
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { userInfo, lanInfo, companyInfo } = useSelector(
    (state) => state.BaseInfo
  );

  const didInitSelect = useRef(false); // 최초 1회만 실행(초기진입 시 첫번째 행 데이터 폼바인딩)

  //#region 파일 업로드 관련
  const { SaveLogicPreview, SaveLogicFile, DeleteLogicFile } = useFileUpload({
    oldFilePathField: 'journeyman',
    newFileNameField: 'journeymanFileNm',
    getTargetPath: (item, custCd) =>
      `Company_Info/${userInfo.coCd}/${custCd}/Journeyman`,
  });
  //#endregion

  //#region 그리드 변수
  const gridState1 = useSelector((state) => state.grid.grid1);
  const setRowData1 = (rows) =>
    dispatch(setRowData({ gridId: 'grid1', rowData: rows }));
  const setDeletedRowData1 = (rows) =>
    dispatch(setDeleted({ gridId: 'grid1', deleted: rows }));
  const setChangedRowData1 = (rows) =>
    dispatch(setChanged({ gridId: 'grid1', changed: rows }));
  const searchInfo = useSelector((s) => s.SearchInfo);
  const [inputs, setInputs] = useState(() => createInitial(PLA_BASIC_Schema));
  const gridRef1 = useRef(); //회사정보 그리드
  const gridRef2 = useRef(); //업종 설정하기 그리드
  const gridRef3 = useRef(); //관리자 관리 그리드
  const gridRef4 = useRef(); //관리자 관리 내부 ID 설정 그리드

  const selectedRowNosRef = useRef(new Set());
  const lastCheckedIndexRef = useRef(null);
  const inputRef = useRef(null); //추가 버튼 시 포커스
  const inputRef2 = useRef(null); //대표자 목록에서 선택 클릭 시 포커스
  const [focusEnabled, setFocusEnabled] = useState(true);

  const fileInputRef = useRef(null);
  const selectedFile = useRef(null);
  const currentRowIndexRef = useRef(null);
  const videoFileStatus = useRef('0');
  const [fileType, setFileType] = useState('0');
  const [fileMap, setFileMap] = useState({});
  const getRowKey = (row) => row.custCd || row.no;
  const [journeymanPreview, setJourneymanPreview] = useState(null);
  // 에러 처리
  const { errorDialog, handleError, clearError } = useErrorHandler();
  // 부분 갱신 처리 (성공한 데이터만 재조회, 실패한 데이터는 유지)
  const { handlePartialRefresh } = usePartialRefresh({
    gridRef: gridRef1,
    changedRowData: gridState1.changed.filter((row) => !row.deleteYn),
    setChangedRowData: setChangedRowData1,
    setRowData: setRowData1,
    getKeyFromRow: (row) => row.custCd,
    getKeyFromResult: (result) => result.custCd,
  });
  const [modalToggle1, setModalToggle1] = React.useState(false); //업종 설정하기 팝업
  const [modalRowData1, setModalRowData1] = useState([]); //업종 설정하기 팝업 그리드 데이터
  const [selectedModalRowData1, setSelectedModalRowData1] = useState([]); //업종 설정하기 팝업 ROW선택 데이터

  const [modalToggle3, setModalToggle3] = React.useState(false); //관리자 관리 팝업 창
  const [modalRowData3, setModalRowData3] = useState([]); //관리자 관리 팝업 창
  const [selectedModalRowData3, setSelectedModalRowData3] = useState([]); //관리자 관리 ROW선택 데이터
  const [changedModalRowData3, setChangedModalRowData3] = useState([]); //관리자 관리 팝업 창 변경 데이터
  const [clickRowId3, setClickRowId3] = useState(null); //관리자 관리 팝업 창 ROW선택 데이터

  const [modalToggle4, setModalToggle4] = React.useState(false); //관리자 관리 내부 ID 설정 팝업 창
  const [modalRowData4, setModalRowData4] = useState([]); //관리자 관리 내부 ID 설정 팝업 창
  const [selectedModalRowData4, setSelectedModalRowData4] = useState([]); //관리자 관리 내부 ID 설정 ROW선택 데이터

  const [modalToggle7, setModalToggle7] = React.useState(false); //직인 설정하기 팝업 창
  const [modalRowData7, setModalRowData7] = useState([]); //직인 설정하기 팝업 창
  const [selectedModalRowData7, setSelectedModalRowData7] = useState([]); //직인 설정하기 ROW선택 데이터

  const [modalToggle8, setModalToggle8] = useState(); // 직인예시 모달

  const [isEditing, setIsEditing] = useState(false);

  const [isComposing, setIsComposing] = useState(false);
  //#endregion
  const { runAsync: Save1Async } = useSave1();
  const { runAsync: Save2Async } = useSave2();
  const { runAsync: Save3Async } = useSave3(inputs.custCd);
  const delete1 = useDelete1();

  const deleteHandler1 = useDelete({
    gridRef: gridRef1,
    gridState: gridState1,
    deleteMutation: delete1,
    updateDeleted: setDeletedRowData1,
    updateRowData: setRowData1,
    rowData: gridState1.rowData,
    setChangedRowData: setChangedRowData1,
  });

  const updateCurrentRowData = (fieldName, value, skipValidation = false) => {
    if (!gridRef1.current || currentRowIndexRef.current === null) return;

    const api = gridRef1.current.api;
    const rowNode = api.getDisplayedRowAtIndex(currentRowIndexRef.current);
    if (!rowNode) return;

    const prevData = rowNode.data;
    const updatedRowData = {
      ...prevData,
      [fieldName]: value,
      editYn: 'Y',
    };

    rowNode.setData(updatedRowData);

    if (
      !skipValidation &&
      (!updatedRowData.custNm || !updatedRowData.custNm.trim())
    ) {
      return;
    }

    if (!Array.isArray(gridState1.changed)) return;

    const alreadyChangedIndex = gridState1.changed.findIndex(
      (item) => item.no === updatedRowData.no
    );
    const newChangedList = [...gridState1.changed];

    if (alreadyChangedIndex > -1) {
      newChangedList[alreadyChangedIndex] = updatedRowData;
    } else {
      newChangedList.push(updatedRowData);
    }

    dispatch(
      setChanged({
        gridId: 'grid1',
        changed: newChangedList,
      })
    );
  };

  const formatBizNo = (val) => val.replace(/[^0-9-]/g, '');

  const handleCompositionStart = () => setIsComposing(true);
  const handleCompositionEnd = (e) => {
    setIsComposing(false);
    const { name, value } = e.target;
    const formatted = formatBizNo(value);
    const updatedInputs = { ...inputs, [name]: formatted, newYn: 'Y' };
    setInputs(updatedInputs);
    updateCurrentRowData(name, formatted);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (isComposing) {
      // IME 중: 입력 그대로
      setInputs({ ...inputs, [name]: value, newYn: 'Y' });
    } else {
      // IME 종료 / 일반 입력: 필드별 포맷 적용
      let formatted = value;

      // 전화번호 필드인 경우 포맷 적용
      if (name === 'custTel') {
        // 숫자만 추출
        const onlyNums = value.replace(/[^0-9]/g, '').slice(0, 11);

        // 전화번호 포맷 적용: 010-1234-5678
        if (onlyNums.length >= 4 && onlyNums.length <= 7) {
          formatted = onlyNums.slice(0, 3) + '-' + onlyNums.slice(3);
        } else if (onlyNums.length >= 8) {
          formatted =
            onlyNums.slice(0, 3) +
            '-' +
            onlyNums.slice(3, 7) +
            '-' +
            onlyNums.slice(7);
        } else {
          formatted = onlyNums;
        }
      } else if (name === 'businessNo') {
        // 사업자등록번호 포맷 적용 (기존 로직)
        formatted = formatBizNo(value);
      } else {
        // 기타 필드는 그대로
        formatted = value;
      }

      setInputs({ ...inputs, [name]: formatted, newYn: 'Y' });
      updateCurrentRowData(name, formatted);
    }
  };

  const tableData = [
    {
      cells: [
        {
          gubun: 'R',
          content: '회사명',
        },
        userInfo.authCd === 'ADMIN'
          ? {
              gubun: 'I',
              type: 'combo',
              items: companyInfo.map((c) => ({
                name: c.coNm,
                value: c.coCd,
              })),
              value: inputs.coCd || '',
              field: 'coCd',
              onChange: (selectedValue) => {
                // 선택된 회사코드
                const selected = companyInfo.find(
                  (c) => c.coCd === selectedValue
                );

                const updatedInputs = {
                  ...inputs,
                  coCd: selected?.coCd || '',
                  coNm: selected?.coNm || '',
                };

                setInputs(updatedInputs);
                updateCurrentRowData('coCd', updatedInputs.coCd);
                updateCurrentRowData('coNm', updatedInputs.coNm);
              },
              disabled: false,
            }
          : {
              gubun: 'I',
              type: 'input',
              value: companyInfo[0]?.coNm || '',
              field: 'coNm',
              disabled: true,
            },
        {
          gubun: 'R',
          content: '대표자',
        },
        {
          gubun: 'I',
          type: 'input',
          value: inputs.companyCeoNm || '',
          field: 'ceo', // 필수
          disabled: true,
        },
      ],
    },
    {
      cells: [
        {
          gubun: 'R',
          content: '사업장명',
        },
        {
          gubun: 'I',
          type: 'input',
          value: inputs.custNm ? inputs.custNm : '',
          field: 'custNm', // 필수
          isRequired: true, // 필수 입력 지정
          maxLength: 20,
          inputRef: inputRef,
          onChange: (e) => {
            const { name, value } = e.target;
            const updatedInputs = { ...inputs, [name]: value, newYn: 'Y' };
            setInputs(updatedInputs);
            updateCurrentRowData(name, value);
          },
        },
        {
          gubun: 'R',
          content: '사업장 대표자',
        },
        {
          gubun: 'I',
          type: 'input',
          value: inputs.ceo ? `${inputs.ceo}` : '',
          field: 'ceo', // 필수
          maxLength: 20,
          onChange: (e) => {
            const { name, value } = e.target;
            const updatedInputs = { ...inputs, [name]: value, newYn: 'Y' };
            setInputs(updatedInputs);
            updateCurrentRowData(name, value);
          },
        },
      ],
    },
    {
      cells: [
        {
          gubun: 'R',
          content: '사업자등록번호',
        },
        {
          gubun: 'I',
          type: 'input',
          value: inputs.businessNo || '',
          field: 'businessNo',
          maxLength: 12, // 하이픈 포함 총 12자리
          onChange: function (e) {
            const name = e.target.name;
            const value = e.target.value;

            // 숫자만 추출
            const onlyNums = value.replace(/[^0-9]/g, '').slice(0, 10);

            // 하이픈 포맷 적용: 123-45-67890
            let formatted = onlyNums;
            if (onlyNums.length >= 4 && onlyNums.length <= 5) {
              formatted = onlyNums.slice(0, 3) + '-' + onlyNums.slice(3);
            } else if (onlyNums.length >= 6) {
              formatted =
                onlyNums.slice(0, 3) +
                '-' +
                onlyNums.slice(3, 5) +
                '-' +
                onlyNums.slice(5);
            }

            const updatedInputs = Object.assign({}, inputs, {
              [name]: formatted,
              newYn: 'Y',
            });

            setInputs(updatedInputs);
            updateCurrentRowData(name, formatted);
          },
          onBlur: function () {
            const bizNo = (inputs.businessNo || '').replace(/[^0-9]/g, '');
            if (bizNo.length === 10 && !validateBizNo(bizNo)) {
              alert('유효하지 않은 사업자등록번호입니다.');
            }
          },
        },
        {
          gubun: 'R',
          content: '사업자관리번호',
        },
        {
          gubun: 'I',
          type: 'input',
          value: inputs.businessMaNo ? `${inputs.businessMaNo}` : '',
          field: 'businessMaNo', // 필수
          maxLength: 20,
          onChange: handleChange,
          onCompositionStart: handleCompositionStart,
          onCompositionEnd: handleCompositionEnd,
        },
      ],
    },
    {
      cells: [
        {
          gubun: 'R',
          content: '사업개시번호',
        },
        {
          gubun: 'I',
          type: 'input',
          value: inputs.businessStartNo ? `${inputs.businessStartNo}` : '',
          field: 'businessStartNo', // 필수
          maxLength: 20,
          onChange: handleChange,
          onCompositionStart: handleCompositionStart,
          onCompositionEnd: handleCompositionEnd,
        },
        {
          gubun: 'R',
          content: (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.3rem',
                fontWeight: 'bold',
              }}
            >
              <Typography
                style={{
                  fontWeight: 'bold',
                  fontSize: '0.9rem',
                }}
              >
                업종(대분류)
              </Typography>

              <Tooltip
                title={'입력창을 클릭하면 업종을 선택할 수 있습니다.'}
                arrow
                enterDelay={300}
                componentsProps={{
                  tooltip: {
                    sx: {
                      fontSize: '0.9rem',
                      padding: '8px 12px',
                      maxWidth: 500,
                      backgroundColor: '#333',
                      whiteSpace: 'pre-wrap',
                    },
                  },
                }}
              >
                <button
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '1rem',
                    borderRadius: '100%',
                    color: '#f44336',
                    border: '1px #e0e0e0 solid',
                    backgroundColor: '#fff',
                    width: '1.4rem',
                    height: '1.4rem',
                    cursor: 'pointer',
                  }}
                >
                  {/* <Icon.QuestionMark
                    style={{
                      width: '1.2rem',
                      height: '1.2rem',
                    }}
                  /> */}
                  <InfoOutlinedIcon
                    fontSize="small"
                    sx={{ color: '#888', flexShrink: 0 }}
                  />
                </button>
              </Tooltip>
            </div>
          ),
        },
        {
          gubun: 'I',
          type: 'input',
          showTooltip: true,
          value: inputs.industrialMain ? inputs.industrialMain : '',
          placeholder: '설정하기',
          field: 'industrialMain', // 필수
          onClick: (e) => {
            PopupClickEvent();
          },
          maxLength: 50,
        },
      ],
    },
    {
      cells: [
        {
          gubun: 'R',
          content: '업종(중분류)',
        },
        {
          gubun: 'I',
          type: 'input',
          showTooltip: true,
          value: inputs.industrialSub ? inputs.industrialSub : '',
          disabled: true,
          field: 'industrialSub', // 필수
          maxLength: 512,
        },
        {
          gubun: 'R',
          content: '업종(소분류)',
        },
        {
          gubun: 'I',
          type: 'input',
          showTooltip: true,
          value: inputs.industrialSmall ? inputs.industrialSmall : '',
          disabled: true,
          field: 'industrialSmall', // 필수
          maxLength: 512,
        },
      ],
    },
    {
      cells: [
        {
          gubun: 'R',
          content: '연락처',
        },
        {
          gubun: 'I',
          type: 'input',
          value: inputs.custTel ? `${inputs.custTel}` : '',
          field: 'custTel', // 필수
          maxLength: 13, // 하이픈 포함 총 13자리 (010-1234-5678)
          onChange: handleChange,
          onCompositionStart: handleCompositionStart,
          onCompositionEnd: handleCompositionEnd,
        },

        {
          gubun: 'R',
          content: (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.3rem',
                fontWeight: 'bold',
              }}
            >
              <Typography
                style={{
                  fontWeight: 'bold',
                  fontSize: '0.9rem',
                }}
              >
                사업장 코드
              </Typography>

              <Tooltip
                title={'회원가입 시 필요한 코드입니다.'}
                arrow
                enterDelay={300}
                componentsProps={{
                  tooltip: {
                    sx: {
                      fontSize: '0.9rem',
                      padding: '8px 12px',
                      maxWidth: 500,
                      backgroundColor: '#333',
                      whiteSpace: 'pre-wrap',
                    },
                  },
                }}
              >
                <button
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '1rem',
                    borderRadius: '100%',
                    color: '#f44336',
                    border: '1px #e0e0e0 solid',
                    backgroundColor: '#fff',
                    width: '1.4rem',
                    height: '1.4rem',
                    cursor: 'pointer',
                  }}
                >
                  <InfoOutlinedIcon
                    fontSize="small"
                    sx={{ color: '#888', flexShrink: 0 }}
                  />
                </button>
              </Tooltip>
            </div>
          ),
        },
        {
          gubun: 'I',
          type: 'input',
          value: inputs.custCd || '',
          field: 'ceo', // 필수
          disabled: true,
        },
      ],
    },
    {
      cells: [
        {
          gubun: 'R',
          content: '소재지',
        },
        {
          gubun: 'I',
          type: 'input',
          value: inputs.location ? inputs.location : '',
          field: 'location', // 필수
          maxLength: 50,
          onChange: (e) => {
            const { name, value } = e.target;
            const updatedInputs = { ...inputs, [name]: value, newYn: 'Y' };
            setInputs(updatedInputs);
            updateCurrentRowData(name, value);
          },
          colSpan: 3,
        },
      ],
    },
    {
      cells: [
        {
          gubun: 'R',
          content: '상시근로자수',
        },
        {
          gubun: 'I',
          type: 'input',
          value: inputs.workNo ? inputs.workNo : '',
          field: 'workNo', // 필수
          disabled: true,
          style: {
            color: '#999',
            cursor: 'not-allowed',
          },
        },
        {
          gubun: 'R',
          content: '수급업체수',
        },
        {
          gubun: 'I',
          type: 'input',
          value: inputs.mstNo ? inputs.mstNo : '',
          field: 'mstNo', // 필수
          disabled: true,
          style: {
            color: '#999',
            cursor: 'not-allowed',
          },
        },
      ],
    },
    {
      cells: [
        {
          gubun: 'R',
          content: (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '0.3rem',
                fontWeight: 'bold',
              }}
            >
              <Typography
                style={{
                  fontWeight: 'bold',
                  fontSize: '0.9rem',
                }}
              >
                직인
              </Typography>
              <button
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '1rem',
                  borderRadius: '100%',
                  color: '#f44336',
                  border: '1px #e0e0e0 solid',
                  backgroundColor: '#fff',
                  width: '1.4rem',
                  height: '1.4rem',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  setModalToggle8(true);
                }}
              >
                <Icon.QuestionMark
                  style={{
                    width: '1.2rem',
                    height: '1.2rem',
                  }}
                />
              </button>
            </div>
          ),
        },
        {
          gubun: 'I',
          type: 'other',
          colSpan: 3,
          placeholder: '설정하기',
          item: (
            <div
              style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}
            >
              <div style={{ display: 'flex', gap: '1rem' }}>
                <FileForm
                  datas={[
                    {
                      type: 'file',
                      sx: { fontSize: 14 },
                      name:
                        lanInfo.length === 0
                          ? ''
                          : lanInfo.find(
                              (f) => f.lanType === 'CALL' && f.lanId === 'File'
                            ).lanNm, //파일
                      onChange: (event) => {
                        const fileList = event.target.files;
                        if (Object.keys(fileList).length === 0) return;

                        const file = fileList[0]; // single file upload

                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = (e) => {
                          fetch(e.target.result)
                            .then((res) => res.blob())
                            .then((blob) => {
                              const canvas = document.createElement('canvas');
                              const ctx = canvas.getContext('2d');

                              const img = new Image();
                              img.crossOrigin = 'Anonymous'; // CORS 문제 방지
                              img.src = reader.result; // 원본 이미지

                              img.onload = function () {
                                canvas.width = img.width;
                                canvas.height = img.height;
                                ctx.drawImage(img, 0, 0);

                                const imageData = ctx.getImageData(
                                  0,
                                  0,
                                  canvas.width,
                                  canvas.height
                                );
                                const data = imageData.data;

                                // 특정 색(흰색) 제거: RGB(255,255,255)에 가까운 색을 투명화
                                for (let i = 0; i < data.length; i += 4) {
                                  const r = data[i]; // Red
                                  const g = data[i + 1]; // Green
                                  const b = data[i + 2]; // Blue
                                  const a = data[i + 3]; // Alpha (투명도)

                                  // 흰색(또는 거의 흰색)이라면 투명하게 변경
                                  if (r > 200 && g > 200 && b > 200) {
                                    data[i + 3] = 0; // 완전 투명하게 설정
                                  }
                                }

                                ctx.putImageData(imageData, 0, 0);

                                // Data URL 형태로 PNG 이미지로 변환
                                const transparentImage =
                                  canvas.toDataURL('image/png'); // 투명한 배경의 PNG 출력

                                // Data URL을 Blob으로 변환
                                fetch(transparentImage)
                                  .then((res) => res.blob()) // Blob으로 변환
                                  .then((blob) => {
                                    // Blob을 File 객체로 변환하여 저장
                                    const image = new File(
                                      [blob],
                                      `${new Date()
                                        .toISOString()
                                        .replace(/T/, '')
                                        .replace(/\..+/, '')
                                        .replace(/-/g, '')
                                        .replace(/:/g, '')}.png`,
                                      {
                                        type: 'image/png',
                                      }
                                    );

                                    setInputs((prev) => ({
                                      ...prev,
                                      journeyman: transparentImage,
                                      journeymanFileNm: file.name,
                                      newYn: 'Y',
                                    }));

                                    updateCurrentRowData(
                                      'journeyman',
                                      transparentImage
                                    );
                                    updateCurrentRowData(
                                      'journeymanFileNm',
                                      file.name
                                    );
                                    const rowKey = getRowKey(inputs);
                                    setFileMap((prev) => ({
                                      ...prev,
                                      [rowKey]: image,
                                    }));
                                  })
                                  .catch((err) => {
                                    console.error(
                                      'Error while converting image to Blob:',
                                      err
                                    );
                                  });
                              };
                            });
                        };
                        reader.onerror = (error) => {
                          console.log(error);
                        };
                      },
                      buttonName:
                        lanInfo.length === 0
                          ? ''
                          : lanInfo.find(
                              (f) =>
                                f.lanType === 'CALL' && f.lanId === 'FileUpload'
                            ).lanNm, //파일 업로드
                    },
                  ]}
                />
                <input
                  type="text"
                  value={inputs.journeymanFileNm || '직인을 등록해주세요.'}
                  disabled
                  style={{
                    display: 'flex',
                    padding: '0.3rem',
                    backgroundColor: 'transparent',
                    border: 'none',
                    borderBottom: '1px solid #ccc',
                    width: '70%',
                    color: '#9e9e9e',
                  }}
                />
              </div>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  height: '50%',
                  position: 'relative',
                }}
              >
                {journeymanPreview || inputs.journeyman ? (
                  <>
                    <img
                      id="fileId"
                      src={
                        inputs.journeyman?.startsWith('data:image') // 사용자가 새로 등록한 base64
                          ? inputs.journeyman
                          : journeymanPreview // 서버에서 받은 base64
                      }
                      alt="직인 이미지"
                      style={{
                        maxWidth: '100%',
                        objectFit: 'contain',
                      }}
                    />

                    <button
                      style={{
                        position: 'absolute',
                        right: '8%',
                        backgroundColor: 'transparent',
                        border: 'none',
                        color: '#f44336',
                        cursor: 'pointer',
                      }}
                      onClick={resetJourneyman}
                    >
                      <Icon.Delete />
                    </button>
                  </>
                ) : (
                  <Typography variant="h6" sx={{ pb: '1rem' }}>
                    등록된 직인이 없습니다.
                  </Typography>
                )}
              </Box>
            </div>
          ),
        },
      ],
    },
    {
      cells: [
        {
          gubun: 'R',
          content: '팩스',
        },
        {
          gubun: 'I',
          type: 'input',
          value: inputs.custFax ? `${inputs.custFax}` : '',
          field: 'custFax', // 필수
          maxLength: 20,
          onChange: handleChange,
          onCompositionStart: handleCompositionStart,
          onCompositionEnd: handleCompositionEnd,
        },
        // {
        //   gubun: 'R',
        //   content: '관리자 관리',
        // },
        // {
        //   gubun: 'I',
        //   type: 'button',
        //   name: '설정하기',
        //   onClick: (e) => {
        //     PopupClickEvent3();
        //   },
        // },
      ],
    },
  ];
  //#endregion
  //조회조건

  useEffect(() => {
    // Init();
  }, []);

  useEffect(() => {
    if (didInitSelect.current) return;

    const gridApi = gridRef1?.current?.api;

    if (gridApi && gridState1.rowData.length > 0) {
      gridApi.deselectAll(); // 기존 선택 초기화
      gridApi.ensureIndexVisible(0, 'middle');
      gridApi.setFocusedCell(0, 'custNm');

      const firstRowNode = gridApi.getDisplayedRowAtIndex(0);
      const firstRowData = firstRowNode?.data;

      if (firstRowData) {
        const copied = JSON.parse(JSON.stringify(firstRowData));
        handleRowSelection(copied, 0);
        firstRowNode.setSelected(true, false);
        didInitSelect.current = true; // 다시 실행되지 않도록 설정
      }
    }
  }, [gridState1.rowData]);

  const { refetch: Search1 } = useSearch1();

  // usePlantManager 훅을 호출하면서 성공 처리 옵션을 전달
  // - dateKey: 조회 결과 rows 중 'cmBirth' 필드를 날짜(YYYY-MM-DD)로 가공
  // - onSuccess: 조회 성공 후 가공된 rows를 받아 모달용 상태로 세팅
  const { run: Search2 } = useSearch2({
    dateKey: 'cmBirth',
    // 서버 조회 성공 + 데이터 가공이 끝난 뒤 실행되는 콜백
    onSuccess: (rows) => {
      setModalRowData3(rows);
    },
  });

  const { run: Search3 } = useSearch3({
    dateKey: 'birth',
    onSuccess: (rows) => {
      setModalRowData4(rows);
    },
  });

  const SearchLogic3 = () => {
    setModalRowData3([]);
    setModalToggle3(true);
    Search2({ CustCd: inputs.custCd });
  };

  const SearchLogic4 = () => {
    setModalRowData4([]);
    setModalToggle4(true);
    Search3({ CoCd: userInfo.coCd });
  };

  //직인 가져오기 (URL 방식으로 변경)
  const SearchLogic7 = (journeyman) => {
    setJourneymanPreview(toPreviewSrc(journeyman));
  };

  //#endregion
  //#region 저장
  const { run: Save3 } = useSave({
    menuId: SCREEN_MENU_ID,
    requiredLabel: '내용',
    getChangedRows: () => Commons.Deduplication(changedModalRowData3),
    requestSave: (rows) => Save3Async(rows),
    reset: () => setChangedModalRowData3([]),
    refresh: () => SearchLogic3(),
  });

  const ResetLogic = () => {
    setInputs(createInitial(PLA_BASIC_Schema));
    selectedFile && (selectedFile.current = {});
    setJourneymanPreview('');
    dispatch(setSelected({ gridId: 'grid1', selected: [] }));
    dispatch(setChanged({ gridId: 'grid1', changed: [] }));
    dispatch(setDeleted({ gridId: 'grid1', deleted: [] }));
  };

  const { run: Save5 } = useSave({
    menuId: SCREEN_MENU_ID,
    requiredLabel: '사업장명',
    schema: PLA_BASIC_Schema,
    getChangedRows: () => gridState1.changed.filter((r) => !r.deleteYn),
    getDeletedRows: () => gridState1.deleted,

    requestDelete: deleteHandler1.DeleteLogic,
    requestSave: (rows) => Save1Async(rows),
    afterSaveRow: async (item, { index, savedRows, userInfo }) => {
      console.log('plant', savedRows);
      const rowKey = getRowKey(item);
      const file = fileMap[rowKey];
      const originalRow = gridState1.rowData.find((r) => r.no === item.no);

      const custCd = savedRows[index]?.custCd || item.custCd;

      let journeymanPath = item.journeyman || originalRow?.journeyman || '';

      // 기존 파일 삭제
      if (!item.journeymanFileNm && originalRow?.journeyman) {
        if (!originalRow.journeyman.startsWith('data:image')) {
          await DeleteLogicFile(originalRow.journeyman);
        }
        journeymanPath = '';
      }
      // 신규 업로드
      else if (file?.size && item.journeyman?.startsWith('data:image')) {
        const previewPath = await SaveLogicPreview(file);

        if (previewPath) {
          const api = gridRef1.current?.api;
          if (api) {
            api.forEachNode((node) => {
              if (node.data?.no === item.no) {
                node.setData({
                  ...node.data,
                  PREVIEW_FILE_PATH: previewPath,
                  journeymanFileNm: file.name,
                  editYn: 'Y',
                });
              }
            });
          }
          await SaveLogicFile(
            {
              ...item,
              PREVIEW_FILE_PATH: previewPath,
              journeymanFileNm: file.name,
            },
            custCd
          );

          journeymanPath = `Company_Info/${userInfo.coCd}/${custCd}/Journeyman/${file.name}`;
        }
      }

      await Save2Async([
        {
          custCd,
          journeyman: journeymanPath,
          journeymanFileNm: item.journeymanFileNm || '',
        },
      ]);
    },

    reset: ResetLogic,
    refresh: Search1,

    partialRefresh: ({ saveResult, changedRows }) =>
      handlePartialRefresh({
        saveResult,
        changedRows,
        searchLogic: Search1,
      }),
  });

  //#endregion
  //#region 팝업 클릭 이벤트
  //업종 클릭 시 이벤트
  const PopupClickEvent = async () => {
    setLoading(true);
    try {
      const res = await Commons.Axios(
        'post',
        Global.base.useUrl + Global.urls.Utility.getIndustryInfo,
        {
          SearchText: Commons.EncryptAES('') || '', //검색창
        }
      );
      const apiRes = res.data;
      const { isSuccess, message, severity, data } = apiRes;
      if (!isSuccess) {
        setModalRowData1([]);
        dispatch(showSnackbar({ message: message, type: severity || 'error' }));
        return;
      }
      const rows = Array.isArray(data) ? data : [];
      if (!rows.length) {
        setModalRowData1([]);
        dispatch(showSnackbar({ message, type: severity || 'info' }));
        return;
      }

      setModalRowData1(Commons.InsertNumber(data));
      setModalToggle1(true);
    } catch (e) {
      // 에러 처리 (401 등은 자동으로 다이얼로그 표시)
      if (e.shouldShowDialog) {
        return;
      }
      await handleError(e, {
        url: Global.base.useUrl + Global.urls.Utility.getIndustry,
        method: 'post',
      });
    } finally {
      setLoading(false);
    }
  };
  //관리자 관리 클릭 시 이벤트
  const PopupClickEvent3 = async () => {
    setLoading(true);
    try {
      if (!inputs.custCd) {
        throw {
          message: '사업장을 저장 후 선택하세요.',
          type: 'warning',
          code: 'CUSTOM_ERROR',
        };
      } else {
        await SearchLogic3();
      }
    } catch (e) {
      console.log(e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: e.code === 'CUSTOM_ERROR' ? e.type : 'error',
        })
      );
    } finally {
      setLoading(false);
    }
  };
  //관리자 관리 안 ID설정 클릭 시 이벤트
  const PopupClickEvent4 = async (e) => {
    setLoading(true);
    try {
      setClickRowId3(e);
      await SearchLogic4();
    } catch (e) {
      console.log(e);
      dispatch(
        showSnackbar({
          message: e.message,
          type: e.code === 'CUSTOM_ERROR' ? e.type : 'error',
        })
      );
    } finally {
      setLoading(false);
    }
  };
  //#endregion
  //#region 나머지 함수
  // 초기화 이벤트

  // 추가 버튼 클릭 이벤트
  const HandleAddClick = async (_gridRef) => {
    dispatch(setSelected({ gridId: 'grid1', selected: [] }));
    if (_gridRef) {
      const api = _gridRef.current.api;
      inputRef.current?.focus(); //첫번째 입력란으로 포커스 이동
      api.deselectAll();

      const newRow = {
        coCd: '', //회사코드
        custCd: '', //사업장코드 (=채번)
        custNm: '', //사업장명
        businessNo: '', //사업자등록번호
        custTel: '', //전화번호
        custFax: '', // 팩스
        ceo: '', //사업장 대표자
        companyCeoNm: '', //회사대표자
        custType: '0', //업체구분(일반,협력업체)
        mstCustCd: '', //소속된 사업장코드
        mstCustNm: '', //소속된 사업장명
        address1: '', //주소
        address2: '', //상세주소
        videoLocation: '', //교육 동영상 위치
        eduLocation: '', //교육파일 위치
        indCd: '', //업종코드
        industrialMain: '', // 업종 - 대분류
        industrialSub: '', // 업종 - 중분류
        industrialSmall: '', // 업종 - 소분류
        indLarge: '', //대분류
        indMiddle: '', //중분류
        indSmall: '', //소분류
        businessMaNo: '', //사업장관리번호
        businessStartNo: '', //사업개시번호
        workNo: 0, //상시근로자수
        mstNo: 0, //수급업체수
        itemNm: '', //(제조업)생산품목
        location: '', //소재지
        contractStatus: '여', //도급여부(여/부)
        original: '', //원도급사명
        journeyman: '', //직인
        journeymanFileNm: '', //직인 파일 명
        no: uuidv4(), //필수값
        newYn: 'Y', //필수값
      };
      _gridRef.current.api.applyTransaction({
        add: [newRow],
        addIndex: 0,
      });
      const addedRowNode = _gridRef.current.api.getDisplayedRowAtIndex(0);
      if (addedRowNode) {
        setInputs(addedRowNode.data);
        setJourneymanPreview('');
        currentRowIndexRef.current = 0;
        addedRowNode.setSelected(true);
      }
    }
  };
  const handleRowSelection = (rowData, rowIndex) => {
    setJourneymanPreview('');
    setInputs({ ...rowData });
    currentRowIndexRef.current = rowIndex;
    dispatch(setSelected({ gridId: 'grid1', selected: [rowData] }));
    if (
      rowData.journeyman?.startsWith('Company_Info/') &&
      !rowData.journeyman?.startsWith('data:image')
    ) {
      const filePath = rowData.journeyman;
      SearchLogic7(filePath);
    }
  };

  const NewYnErrorMsg = () => {
    dispatch(
      showSnackbar({
        message: '데이터 입력중입니다. 저장 후 시도하세요.',
        type: 'warning',
      })
    );
  };

  function resetJourneyman() {
    const rowKey = getRowKey(inputs);

    setInputs((prev) => ({
      ...prev,
      journeyman: '',
      journeymanFileNm: '',
      journeymanFile: null,
    }));
    setJourneymanPreview('');
    updateCurrentRowData('journeyman', '');
    updateCurrentRowData('journeymanFileNm', '');
    updateCurrentRowData('journeymanFile', null);

    if (selectedFile.current?.journeyman) {
      delete selectedFile.current.journeyman;
    }
    setFileMap((prev) => {
      const newMap = { ...prev };
      if (newMap[rowKey]) {
        delete newMap[rowKey];
      }
      return newMap;
    });
  }

  // 사업자변호 정규식
  function validateBizNo(bizNo) {
    if (!/^\d{10}$/.test(bizNo)) return false;

    const checkArr = [1, 3, 7, 1, 3, 7, 1, 3, 5];
    const nums = bizNo.split('').map(function (digit) {
      return parseInt(digit, 10);
    });

    let sum = 0;
    for (let i = 0; i < 9; i++) {
      sum += nums[i] * checkArr[i];
    }

    sum += Math.floor((nums[8] * 5) / 10);
    const checkDigit = (10 - (sum % 10)) % 10;

    return nums[9] === checkDigit;
  }
  //#endregion

  return (
    <div className="wrap">
      <PLA_BASIC
        gridId1={'grid1'}
        inputs={inputs}
        setInputs={setInputs}
        rowData={gridState1.rowData}
        selectedRowData={gridState1.selected}
        changedRowData={gridState1.changed}
        setSelectedRowData={(sel) =>
          dispatch(setSelected({ gridId: 'grid1', selected: sel }))
        }
        setChangedRowData={(sel) =>
          dispatch(setChanged({ gridId: 'grid1', changed: sel }))
        }
        userInfo={userInfo}
        lanInfo={lanInfo}
        setIsEditing={setIsEditing}
        modalToggle1={modalToggle1}
        setModalToggle1={setModalToggle1}
        modalRowData1={modalRowData1}
        selectedModalRowData1={selectedModalRowData1}
        setSelectedModalRowData1={setSelectedModalRowData1}
        modalToggle7={modalToggle7}
        setModalToggle7={setModalToggle7}
        modalRowData7={modalRowData7}
        setModalRowData7={setModalRowData7}
        selectedModalRowData7={selectedModalRowData7}
        setSelectedModalRowData7={setSelectedModalRowData7}
        modalToggle8={modalToggle8}
        setModalToggle8={setModalToggle8}
        setRowData={setRowData}
        colWidth={COL_WIDTH}
        tableData={tableData}
        fileInputRef={fileInputRef}
        videoFileStatus={videoFileStatus}
        fileType={fileType}
        setFileType={setFileType}
        selectedFile={selectedFile}
        isEditing={isEditing}
        gridRef1={gridRef1}
        gridRef2={gridRef2}
        gridRef3={gridRef3}
        gridRef4={gridRef4}
        modalToggle3={modalToggle3}
        setModalToggle3={setModalToggle3}
        modalRowData3={modalRowData3}
        setModalRowData3={setModalRowData3}
        selectedModalRowData3={selectedModalRowData3}
        setSelectedModalRowData3={setSelectedModalRowData3}
        changedModalRowData3={changedModalRowData3}
        setChangedModalRowData3={setChangedModalRowData3}
        clickRowId3={clickRowId3}
        setClickRowId3={setClickRowId3}
        modalToggle4={modalToggle4}
        setModalToggle4={setModalToggle4}
        modalRowData4={modalRowData4}
        setModalRowData4={setModalRowData4}
        selectedModalRowData4={selectedModalRowData4}
        setSelectedModalRowData4={setSelectedModalRowData4}
        inputRef={inputRef}
        inputRef2={inputRef2}
        focusEnabled={focusEnabled}
        setFocusEnabled={setFocusEnabled}
        searchRef={searchInfo}
        selectedRowNosRef={selectedRowNosRef}
        lastCheckedIndexRef={lastCheckedIndexRef}
        // 함수
        SearchLogic1={Search1}
        SaveLogic3={Save3}
        SaveLogic5={Save5}
        ResetLogic={ResetLogic}
        NewYnErrorMsg={NewYnErrorMsg}
        HandleAddClick={HandleAddClick}
        handleRowSelection={handleRowSelection}
        MarkedForDeletion={deleteHandler1.MarkedForDeletion}
        RestoreRow={deleteHandler1.RestoreRow}
        updateCurrentRowData={updateCurrentRowData}
        DeleteNewRow1={deleteHandler1.DeleteNewRow}
        PopupClickEvent={PopupClickEvent}
        PopupClickEvent4={PopupClickEvent4}
      />
      <Loading open={loading} />
    </div>
  );
}

export default PLA_BASICF;
